import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

import { applyTheme, getTheme } from "../lib/theme";
import { HomeStillWater, usePrefersReducedMotion } from "./marketing/HomeStillWater";
import { MarketingFooter, MarketingHeader } from "./marketing/MarketingChrome";
import { useHeaderOffset } from "./marketing/useHeaderOffset";
import "./marketing/landing-palette.css";

/**
 * One entry of a section rail. The pitch and feature pages build their rail
 * from this shape; the home page has no rail (#2443).
 */
export type LandingSection = {
  id: string;
  no: string;
  name: string;
  tint: "linen" | "sky" | "clay" | null;
};

export function LandingPage() {
  useHeaderOffset();
  const { hash } = useLocation();
  useLayoutEffect(() => {
    if (hash) document.getElementById(hash.slice(1))?.scrollIntoView({ block: "start" });
  }, [hash]);
  // Pin the public landing to `sage-clinic` (founder direction
  // 2026-08-01). `applyTheme` writes ONLY the `<html data-theme>`
  // attribute; the stored preference is never touched, and `getTheme()`
  // restores it on unmount. A layout effect so the swap lands before paint.
  useLayoutEffect(() => {
    applyTheme("sage-clinic");
    return () => applyTheme(getTheme());
  }, []);

  // #2788: a visitor who asked for less motion gets the story paused, with a
  // Play button.
  const osReduced = usePrefersReducedMotion();
  const reduced = osReduced;

  return (
    <div data-la-root="" data-motion={reduced ? "still" : "loop"} className="hsw min-h-screen">
      <div className="la-pinned-header">
        <div className="la-pinned-header-inner">
          <MarketingHeader />
        </div>
      </div>
      <HomeStillWater reduced={reduced} />
      <div className="hsw-foot">
        <MarketingFooter />
      </div>
    </div>
  );
}
